import React from 'react';

interface FinancialSettings {
  enableMultiCurrency: boolean;
  enableTaxCalculation: boolean;
  enableVAT: boolean;
  taxRate: number;
  vatRate: number;
}

interface FinancialTabProps {
  settings: FinancialSettings;
  onUpdate: (patch: Partial<FinancialSettings>) => void;
}

const FinancialTab: React.FC<FinancialTabProps> = ({ settings, onUpdate }) => (
  <div className="space-y-6">
    <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
      <h3 className="font-semibold text-blue-900 mb-2">Financial Settings</h3>
      <p className="text-sm text-blue-800">Configure financial and tax-related settings</p>
    </div>

    <div className="space-y-4">
      <div className="flex items-center">
        <input type="checkbox" checked={settings.enableMultiCurrency}
          onChange={(e) => onUpdate({ enableMultiCurrency: e.target.checked })}
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
        <label className="ml-2 block text-sm text-gray-900">Enable Multi-Currency Support</label>
      </div>
      <div className="flex items-center">
        <input type="checkbox" checked={settings.enableTaxCalculation}
          onChange={(e) => onUpdate({ enableTaxCalculation: e.target.checked })}
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
        <label className="ml-2 block text-sm text-gray-900">Enable Tax Calculation</label>
      </div>
      <div className="flex items-center">
        <input type="checkbox" checked={settings.enableVAT}
          onChange={(e) => onUpdate({ enableVAT: e.target.checked })}
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
        <label className="ml-2 block text-sm text-gray-900">Enable VAT</label>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Tax Rate (%)</label>
        <input
          type="number"
          value={settings.taxRate}
          onChange={(e) => onUpdate({ taxRate: parseFloat(e.target.value) })}
          min="0" max="100" step="0.01"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">VAT Rate (%)</label>
        <input
          type="number"
          value={settings.vatRate}
          onChange={(e) => onUpdate({ vatRate: parseFloat(e.target.value) })}
          min="0" max="100" step="0.01"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
  </div>
);

export default FinancialTab;
